// ****************App Widget Height Fix***************

// (function() {
//   function getWidgetIframe() {
//     const container = document.getElementById('bta-widget-container');
//     if (!container) return null;
//     const innerDiv = container.querySelector('div:first-child');
//     if (!innerDiv) return null;
//     return innerDiv.querySelector('iframe');
//   }

//   function applyHeight(newHeight) {
//     if (!newHeight || newHeight < 100) return;

//     const container = document.getElementById('bta-widget-container');
//     if (!container) return;

//     const innerDiv = container.querySelector('div:first-child');
//     const iframe = innerDiv?.querySelector('iframe');

//     // ✅ Fix iframe itself — critical for iOS
//     if (iframe) {
//       iframe.style.setProperty('height', newHeight + 'px', 'important');
//       iframe.style.setProperty('min-height', newHeight + 'px', 'important');
//       iframe.style.setProperty('overflow', 'hidden', 'important');
//       iframe.scrolling = 'no'; // ✅ Disables internal scroll on iOS
//     }

//     // ✅ Fix inner wrapper div
//     if (innerDiv) {
//       innerDiv.style.setProperty('height', newHeight + 'px', 'important');
//       innerDiv.style.setProperty('min-height', newHeight + 'px', 'important');
//       innerDiv.style.setProperty('overflow', 'visible', 'important');
//     }

//     // ✅ Fix main container
//     container.style.setProperty('height', 'auto', 'important');
//     container.style.setProperty('min-height', newHeight + 'px', 'important');
//     container.style.setProperty('overflow', 'visible', 'important');

//     // ✅ Walk UP ancestors and remove fixed heights
//     let parent = container.parentElement;
//     while (parent && parent !== document.body) {
//       const computedHeight = window.getComputedStyle(parent).height;
//       const inlineStyle = parent.getAttribute('style') || '';
//       if (/height\s*:\s*\d+px/.test(inlineStyle) || parseInt(computedHeight) < newHeight) {
//         parent.style.setProperty('height', 'auto', 'important');
//         parent.style.setProperty('min-height', newHeight + 'px', 'important');
//         parent.style.setProperty('overflow', 'visible', 'important');
//       }
//       parent = parent.parentElement;
//     }

//     // ✅ Fix next siblings that may be collapsing
//     let sibling = container.nextElementSibling;
//     while (sibling) {
//       const inlineStyle = sibling.getAttribute('style') || '';
//       if (/height\s*:\s*\d+px/.test(inlineStyle)) {
//         sibling.style.setProperty('height', 'auto', 'important');
//       }
//       sibling = sibling.nextElementSibling;
//     }
//   }

//   // ✅ postMessage listener (primary method)
//   window.addEventListener('message', function(event) {
//     if (!event.origin || !event.origin.includes('bookthatapp.com')) return;
//     if (event.data && (event.data.type === 'bta:resize' || event.data.type === 'resize')) {
//       const newHeight = event.data.height;
//       if (newHeight && typeof newHeight === 'number') {
//         applyHeight(newHeight);
//       }
//     }
//   });

//   // ✅ Fallback: try same-origin read (won't work cross-origin but worth trying)
//   function tryReadIframeHeight() {
//     const iframe = getWidgetIframe();
//     if (!iframe) return;
//     try {
//       const doc = iframe.contentDocument || iframe.contentWindow?.document;
//       if (doc && doc.body) {
//         const h = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight);
//         if (h > 100) applyHeight(h);
//       }
//     } catch(e) { /* cross-origin, skip */ }
//   }

//   // ✅ ResizeObserver — catches iOS dynamic resizes
//   function setupObserver(iframe) {
//     if (!window.ResizeObserver) return;
//     const ro = new ResizeObserver(function(entries) {
//       for (const entry of entries) {
//         const h = entry.contentRect.height;
//         if (h > 100) applyHeight(h);
//       }
//     });
//     ro.observe(iframe);
//   }

//   function waitForIframe() {
//     const iframe = getWidgetIframe();
//     if (iframe) {
//       tryReadIframeHeight();
//       setupObserver(iframe);

//       iframe.addEventListener('load', function() {
//         setTimeout(tryReadIframeHeight, 300);
//         setTimeout(tryReadIframeHeight, 1000); // iOS sometimes needs extra delay
//       });
//     } else {
//       setTimeout(waitForIframe, 500);
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', waitForIframe);
//   } else {
//     waitForIframe();
//   }

//   // ✅ iOS-safe polling fallback — runs for first 30 seconds
//   var pollCount = 0;
//   var pollInterval = setInterval(function() {
//     pollCount++;
//     if (pollCount > 15) {
//       clearInterval(pollInterval); // Stop after 30s
//       return;
//     }

//     const container = document.getElementById('bta-widget-container');
//     if (!container) return;

//     const iframe = container.querySelector('iframe');
//     if (!iframe) return;

//     // If iframe has a scroll height we can read, use it
//     tryReadIframeHeight();

//     // If iframe still has a small fixed height, force it larger
//     const currentH = parseInt(iframe.style.height);
//     if (currentH && currentH < 400) {
//       iframe.style.setProperty('height', 'auto', 'important');
//       iframe.style.setProperty('min-height', '800px', 'important'); // Safe fallback
//     }

//     // Clear any fixed heights on ancestors
//     let parent = container.parentElement;
//     while (parent && parent !== document.body) {
//       const inlineStyle = parent.getAttribute('style') || '';
//       if (/height\s*:\s*\d+px/.test(inlineStyle)) {
//         parent.style.setProperty('height', 'auto', 'important');
//         parent.style.setProperty('overflow', 'visible', 'important');
//       }
//       parent = parent.parentElement;
//     }
//   }, 2000);
// })();






// (function () {
//   'use strict';

//   var ORIGIN_MATCH   = 'bookthatapp.com';
//   var MIN_HEIGHT     = 100;
//   var POLL_INTERVAL  = 2000;
//   var POLL_MAX       = 20;
//   var ANCESTOR_LIMIT = 8;
//   // Extra padding added on unlock so the button below the fold is always visible
//   // before BTA sends its resize message. BTA will correct to exact height after.
//   var UNLOCK_PADDING = 180;

//   var lastApplied    = 0;
//   var debounceTimer  = null;
//   var pollCount      = 0;
//   var pollTimer      = null;
//   var roInstance     = null;
//   var justUnlocked   = false;

//   function getContainer() {
//     return document.getElementById('bta-widget-container');
//   }

//   function getIframe() {
//     var c = getContainer();
//     if (!c) return null;
//     var inner = c.querySelector('div:first-child') || c;
//     return inner.querySelector('iframe') || c.querySelector('iframe');
//   }

//   function applyHeight(newHeight) {
//     if (!newHeight || newHeight < MIN_HEIGHT) return;
//     if (lastApplied > 0 && Math.abs(newHeight - lastApplied) < 2) return;
//     lastApplied  = newHeight;
//     justUnlocked = false;

//     var container = getContainer();
//     if (!container) return;

//     var inner  = container.querySelector('div:first-child');
//     var iframe = getIframe();

//     if (iframe) {
//       iframe.style.setProperty('height',     newHeight + 'px', 'important');
//       iframe.style.setProperty('min-height', newHeight + 'px', 'important');
//       iframe.style.setProperty('max-height', 'none',           'important');
//       iframe.style.setProperty('overflow',   'visible',        'important');
//       iframe.scrolling = 'no';
//     }
//     if (inner) {
//       inner.style.setProperty('height',     newHeight + 'px', 'important');
//       inner.style.setProperty('min-height', newHeight + 'px', 'important');
//       inner.style.setProperty('overflow',   'visible',        'important');
//     }
//     container.style.setProperty('height',     'auto',           'important');
//     container.style.setProperty('min-height', newHeight + 'px', 'important');
//     container.style.setProperty('overflow',   'visible',        'important');

//     var parent = container.parentElement;
//     var steps  = 0;
//     while (parent && parent !== document.body && steps < ANCESTOR_LIMIT) {
//       var inlineStyle = parent.getAttribute('style') || '';
//       var match = inlineStyle.match(/(?:^|;)\s*height\s*:\s*(\d+(?:\.\d+)?)px/i);
//       if (match && parseFloat(match[1]) < newHeight) {
//         parent.style.setProperty('height',     'auto',           'important');
//         parent.style.setProperty('min-height', newHeight + 'px', 'important');
//         parent.style.setProperty('overflow',   'visible',        'important');
//       }
//       parent = parent.parentElement;
//       steps++;
//     }
//   }

//   function scheduleApply(height) {
//     if (debounceTimer) clearTimeout(debounceTimer);
//     if (justUnlocked) {
//       applyHeight(height);
//     } else {
//       debounceTimer = setTimeout(function () { applyHeight(height); }, 80);
//     }
//   }

//   // ── Transition unlock ─────────────────────────────────────────────────────
//   // Problem: cross-origin iframe — we cannot read scrollHeight after view change.
//   // BTA's resize postMessage may arrive late or not at all for some views.
//   // Solution: at the moment of unlock, immediately expand the iframe by
//   // UNLOCK_PADDING px beyond its current height. This is enough to reveal the
//   // button. BTA's next resize message (or the ResizeObserver) will then correct
//   // to the exact final height.
//   function unlockHeight() {
//     if (debounceTimer) clearTimeout(debounceTimer);

//     var container   = getContainer();
//     var iframe      = getIframe();
//     var inner       = container && container.querySelector('div:first-child');
//     var expandedH   = (lastApplied || MIN_HEIGHT) + UNLOCK_PADDING;

//     if (iframe) {
//       iframe.style.removeProperty('height');
//       iframe.style.setProperty('min-height', expandedH + 'px', 'important');
//       iframe.style.setProperty('overflow',   'visible',        'important');
//     }
//     if (inner) {
//       inner.style.removeProperty('height');
//       inner.style.setProperty('min-height', expandedH + 'px', 'important');
//       inner.style.setProperty('overflow',   'visible',        'important');
//     }
//     if (container) {
//       container.style.setProperty('min-height', expandedH + 'px', 'important');
//       container.style.setProperty('overflow',   'visible',        'important');
//     }

//     // Also push any ancestors that are too small
//     if (container) {
//       var parent = container.parentElement;
//       var steps  = 0;
//       while (parent && parent !== document.body && steps < ANCESTOR_LIMIT) {
//         var inlineStyle = parent.getAttribute('style') || '';
//         var match = inlineStyle.match(/(?:^|;)\s*height\s*:\s*(\d+(?:\.\d+)?)px/i);
//         if (match && parseFloat(match[1]) < expandedH) {
//           parent.style.setProperty('height',     'auto',            'important');
//           parent.style.setProperty('min-height', expandedH + 'px',  'important');
//           parent.style.setProperty('overflow',   'visible',         'important');
//         }
//         parent = parent.parentElement;
//         steps++;
//       }
//     }

//     lastApplied  = 0;
//     justUnlocked = true;

//     // Poll after unlock in case BTA sends no resize message
//     setTimeout(tryReadIframeHeight, 200);
//     setTimeout(tryReadIframeHeight, 600);
//     setTimeout(tryReadIframeHeight, 1200);
//   }

//   window.addEventListener('message', function (event) {
//     if (!event.origin || event.origin.indexOf(ORIGIN_MATCH) === -1) return;
//     var d = event.data;
//     if (!d) return;

//     if (d.type === 'bta:view' || d.type === 'bta:navigate' || d.type === 'navigate') {
//       unlockHeight();
//       return;
//     }

//     var h = null;
//     if ((d.type === 'bta:resize' || d.type === 'resize') && typeof d.height === 'number') {
//       h = d.height;
//     } else if (typeof d === 'number' && d > MIN_HEIGHT) {
//       h = d;
//     }

//     if (h && h > MIN_HEIGHT) scheduleApply(h);
//   });

//   function attachClickUnlock(iframe) {
//     iframe.addEventListener('pointerdown', unlockHeight, { passive: true });
//   }

//   function tryReadIframeHeight() {
//     var iframe = getIframe();
//     if (!iframe) return;
//     try {
//       var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
//       if (doc && doc.body) {
//         var h = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight);
//         if (h > MIN_HEIGHT) scheduleApply(h);
//       }
//     } catch (e) { /* cross-origin */ }
//   }

//   function attachObserver(iframe) {
//     if (!window.ResizeObserver) return;
//     if (roInstance) roInstance.disconnect();
//     roInstance = new ResizeObserver(function (entries) {
//       for (var i = 0; i < entries.length; i++) {
//         var h = entries[i].contentRect.height;
//         if (h > MIN_HEIGHT) scheduleApply(h);
//       }
//     });
//     roInstance.observe(iframe);
//   }

//   function init() {
//     var iframe = getIframe();
//     if (!iframe) { setTimeout(init, 500); return; }

//     tryReadIframeHeight();
//     attachObserver(iframe);
//     attachClickUnlock(iframe);

//     iframe.addEventListener('load', function () {
//       setTimeout(tryReadIframeHeight, 300);
//       setTimeout(tryReadIframeHeight, 1200);
//     });

//     startPolling();
//   }

//   function startPolling() {
//     if (pollTimer) clearInterval(pollTimer);
//     pollCount = 0;
//     pollTimer = setInterval(function () {
//       pollCount++;
//       if (pollCount > POLL_MAX) { clearInterval(pollTimer); pollTimer = null; return; }
//       var iframe = getIframe();
//       if (!iframe) return;
//       tryReadIframeHeight();
//       var appliedH = parseInt(iframe.style.height, 10);
//       if ((!appliedH || appliedH < MIN_HEIGHT) && pollCount === 1) {
//         iframe.style.setProperty('min-height', '400px', 'important');
//       }
//     }, POLL_INTERVAL);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();







function removeEmptyJudgeMe() {
  document.querySelectorAll('.jdgm-widget').forEach(widget => {

    const badge = widget.querySelector('.jdgm-prev-badge');
    if (!badge) return;

    const reviewCount = badge.dataset.numberOfReviews;
    const rating = badge.dataset.averageRating;

    if (reviewCount === "0" || rating === "0.00") {
      widget.remove();
    }

  });
}



document.addEventListener("click", function (e) {

  if (e.target.closest(".m-collapsible--button")) {

    const btn = e.target.closest(".m-collapsible--button");
    
    if (btn.innerText.includes("Umsagnir")) {

      setTimeout(() => {
        const reviewSection = document.querySelector("#judgeme_product_reviews");

        if (reviewSection) {
          reviewSection.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }

      }, 300);
    }
  }

});



function wrapAlsoBought() {
  const headings = document.querySelectorAll(
    ".m-product-recommendations .m-section__heading"
  );

  headings.forEach(heading => {
    if (
      heading.textContent.includes("Also Bought") &&
      !heading.querySelector("span")
    ) {
      heading.innerHTML = heading.innerHTML.replace(
        "Also Bought",
        "<span>Also Bought</span>"
      );
    }
  });
}

/* Run initially */
document.addEventListener("DOMContentLoaded", wrapAlsoBought);

/* Watch for dynamic load */
const observer = new MutationObserver(wrapAlsoBought);
observer.observe(document.body, { childList: true, subtree: true });


document.addEventListener("DOMContentLoaded", function () {
  const title = document.querySelector(".m-product-title");

  if (title) {
    const text = title.textContent;

    if (text.includes("-")) {
      const parts = text.split("-");

      title.innerHTML = `
        ${parts[0].trim()} 
       - <span class="title-highlight"> ${parts.slice(1).join("-").trim()}</span>
      `;
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq-item");

  faqItems.forEach(item => {
    item.addEventListener("toggle", function () {

      if (item.open) {
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.removeAttribute("open");
          }
        });
      }

    });
  });
});



document.addEventListener("DOMContentLoaded", () => {
  const rows = document.querySelectorAll("section#loftthurrkun-samanburdur tbody tr");

  rows.forEach(row => {
    const cols = row.querySelectorAll("td");

    [1, 2].forEach(index => {
      const td = cols[index];
      if (!td) return;

      const span = td.querySelector("span");
      if (!span) return;

      let text = span.textContent.trim();

      // Match percentage
      const percentMatch = text.match(/\d+\s*–\s*\d+%/);

      if (percentMatch) {
        // --- If percentage exists ---
        const percent = percentMatch[0];
        let remainingText = text.replace(percent, "").trim();

        span.textContent = percent;
        td.innerHTML = span.outerHTML + (remainingText ? " " + remainingText : "");

      } else {
        // --- If NO percentage → remove span completely ---
        td.textContent = text;
      }
    });

    // Fix duplicate Minerals → Digestibility
    if (
      cols[0] &&
      cols[0].textContent.trim() === "Minerals" &&
      row.textContent.toLowerCase().includes("digest")
    ) {
      cols[0].innerHTML = "<b>Digestibility</b>";
    }
  });
});
